import { createSelector } from 'reselect';

export const getMarketing = createSelector(
  state => state?.dashboard?.marketing,
  notarize => notarize
);

export const getRescheduleModal = createSelector(
  state => state.orderPlaced.rescheduleModal,
  rescheduleModal => rescheduleModal
);

export const getSchedule = createSelector(
  state => state.dashboard.orderSummary.schedule,
  schedule => schedule
);
